/* custom js here */
$(document).ready(function() {
    //redirect to the availability collections    
    var location_pass = location.href;
    if(location_pass.includes('collections') && !location_pass.includes('filter.v.availability=1')) {
        if(location_pass.includes('myshopify.com/collections')) {//in case of admin collection page
            var pass_items = location_pass.split("?");
            var full_pass = pass_items[0] + "?filter.v.availability=1&" + pass_items[1];
            location.href = full_pass;
        } else {
            var available_col = location_pass+"?filter.v.availability=1";
            location.href = available_col;
        }        
    }
    //
    $(document).on('click', '#show_filter_btn', function() {
        $('.feature-divider').slideToggle();
        $('.sidebar-wrap').slideToggle();
    })
})